/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './AnnotationRecordingInfo.css';
import ContentHeader from 'legacy/containers/ContentHeader';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from '@material-ui/core/styles';
import { initFetch } from '../../state';
import moment from 'moment';
import {
  submitCCTAnotator,
  fetchCCTAnotator,
} from '../../../../../legacy/containers/ApiUrls';
import { handleOnExportClick } from '../../../../../legacy/containers/EkgRecordingReviewScreen/module';
import FormattedDate from '../../../../components/Common/FormattedDate';
// constants / utilities
import {
  getDateInDaysHoursMinuit,
  getFormattedDate,
} from '../../../../components/Common/Table/Utilities/DateUtilities';

import { getDateFormat, getTimeFormat } from 'legacy/constants';

import { getEKGAlgorithmDeterminationDisplayText } from '../../../../../legacy/constants/recordingMaps';
import history from '../../../../../legacy/containers/History';
import { createRoute } from 'routes/patientRouteUtils';
import { updateSelectedTab } from 'state/reducers/patient/patientActions';
import { PATIENT_FILE_TABS } from 'views/pages/PatientFile/PatientFileUtils';

import { printTechIntrString } from '../../utils/TechIntrParser';
/* For setting the height of Select Dropdown  */
const useStyles = makeStyles(theme => ({
  menuPaper: {
    maxHeight: 130,
  },
}));

const AnnotationRecordingInfo = (props) => {
  const dispatch = useDispatch();
  const me = useSelector(state => state.app.dataSources.me);
  const Annotator = useSelector(state => state.annotator);
  const recordingId = useSelector(state => state.annotator.recordingId);
  const recordingInfo = useSelector(state => state.annotator.recordingInfo);
  const Rhythms = useSelector(state => state.annotator.baseRhythm);
  const isCompleted = false;
    // useSelector(state => state.annotator.recordingInfo.annotation.inbox) === 4;
  const sendToList = recordingInfo.inboxes;
  const [SendTo, setSendTo] = useState(recordingInfo.annotation.inbox);
  const [ECGType, setECGType] = useState(recordingInfo.annotation.acuity);
  const [Reason, setReason] = useState(
    recordingInfo.annotation.archive_reasons,
  );
  const [HighlightStripeType, setHighlightStripeType] = useState(
    recordingInfo.annotation.highlight_strip ? 'true' : 'false',
  );
  const [BaseRhythm, setBaseRhythm] = useState(
    Annotator.recordingInfo.annotation.base_rhythm_interpretation_id,
  );
  const [IncidentalFindings, setIncidentalFindings] = useState(
    recordingInfo.annotation.incidental_findings || '',
  );
  const [TechInterpretation, setTechInterpretation] = useState(
    Annotator.interpretation.intervals || [],
  );
  const [TechInterpretationsText, setTechInterpretationText] = useState('');
  const classes = useStyles();

  const handleSendToChange = e => {
    setSendTo(e.target.value);
  };

  const handleReasonToChange = e => {
    setReason(e.target.value);
  };
  const handleTypeChange = e => {
    setECGType(e.target.value);
  };

  const handleTypeChangeForStripHighlight = e => {
    setHighlightStripeType(e.target.value);
  };

  const handleBaseRhythmChange = e => {
    setBaseRhythm(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(initFetch());
    console.log(
      'HighlightStripeType>>>',
      typeof HighlightStripeType,
      HighlightStripeType,
    );
    const br = Rhythms.filter(item => item.id === BaseRhythm)[0];
    const veBeatArray = Annotator.interpretation.beats.filter(b => b[1] == 3);
    const sveBeatArray = Annotator.interpretation.beats.filter(b => b[1] == 5);

    // ===== Highlight Sample =====
    const ld = Annotator.highlight.LeadData ? Annotator.highlight.LeadData : 'leadI'
    const si = Annotator.highlight.LeadData ? Annotator.highlight.leftIndex : 0
    const ei = Annotator.highlight.LeadData ? Annotator.highlight.rightIndex : 1800
    
    const newSample = Annotator.samples.samples[ld].slice(si,ei)
    const beatBetween = Annotator.interpretation.beats.filter(b => {return b[0] >= si && b[0]<=ei && b[1] < 4}).map(e=>[e[0]-si,e[1]]);
  
    let highlight_sample = {
      beats : beatBetween,
      intervals : [{
        lead: ld,
        samples: newSample
      }]
    }

    const payload = {
      ...recordingInfo.annotation,
      // "archive_reason": 1,
      incidental_findings: IncidentalFindings,
      archive_reason: Reason,
      acuity: ECGType,
      base_rhythm_interpretation_id: BaseRhythm,
      inbox: SendTo,
      data: JSON.stringify(Annotator.interpretation),
      highlight_strip: HighlightStripeType === 'true' ? true : false,
      tech_interpretation: JSON.stringify({
        base: {
          rhythm_id: br ? br.id : null,
          rhythm_name: br ? br.name : null,
          rhythm_package: recordingInfo.recording.algorithm_package,
          bpm: recordingInfo.recording.overall_average,
        },
        intervals: [...Annotator.interpretation.intervals],
        veBeatCount: veBeatArray.length,
        sveBeatCount: sveBeatArray.length,
      }),
      highlight_interval: JSON.stringify([Annotator.highlight]),
      preview:JSON.stringify(highlight_sample),
    };
    // dispatch(submitCCTAnotator(recordingId, payload))
    // console.log("API SUBMIT =>",payload)
    // console.log('payload>>', payload);
    const apiCalls = [];
    apiCalls.push(dispatch(submitCCTAnotator(recordingId, payload)));
    Promise.all(apiCalls);
  };

  useEffect(() => {
    console.log(props)
  }, []);

  const getAge = (d1, d2) => {
    d2 = d2 || new Date();
    var diff = d2.getTime() - d1.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  };
  const handleIncidentalFindingsChange = e => {
    setIncidentalFindings(e.target.value);
  };

  let monitoringDate = 0;
  // get the monitoring from patient info object
  if (
    recordingInfo &&
    recordingInfo.patient &&
    recordingInfo.patient.study_period_starts_at
  ) {
    monitoringDate = getDateInDaysHoursMinuit(
      recordingInfo.patient.study_period_starts_at,
      null,
    );
  }

  let kav2Ditermination = '';
  // get the determination
  if (
    recordingInfo &&
    recordingInfo.recording &&
    recordingInfo.recording.algorithm_determination
  ) {
    kav2Ditermination = getEKGAlgorithmDeterminationDisplayText(
      recordingInfo.recording.algorithm_determination,
      recordingInfo.recording.algorithm_package,
    );
  }

  // get Tech Interpretations
  const getTechInterpretations = Intervals => {
    // let techInterpretations = ''
    let data = '';
    // const br = Rhythms.filter(item => item.id === BaseRhythm)[0]
    // const veBeatArray = Annotator.interpretation.beats.filter(b=>b[1]==3)
    // data = printTechIntrString({
    //   base:{
    //     rhythm_id: br ? br.id : null,
    //     rhythm_name:  br ? br.name : null,
    //     rhythm_package: recordingInfo.recording.algorithm_package,
    //     bpm:recordingInfo.recording.overall_average,
    // },
    // intervals:[...Intervals],
    // veBeatCount: veBeatArray.length,})
    const veBeatArrayLen = Annotator.interpretation.beats.filter(b => b[1] == 3).length;
    const sveBeatArrayLen = Annotator.interpretation.beats.filter(b => b[1] == 5).length;
    if (Intervals.length) {
      Intervals.forEach(techIntr => {
        const IntervalRythmType = Rhythms.find(
          rm => rm.id === techIntr.type.id,
        );
        if (IntervalRythmType) {
          if (techIntr.type.name === 'Pause') {
            data = data !== '' ? data + ', ' : '';
            data =
              data +
              `${techIntr.type.name} ${(
                techIntr.time.end - techIntr.time.start
              ).toFixed(2)} seconds`;
          } else {
            data = data !== '' ? data + ', ' : '';
            if (techIntr.bpm) {
              data =
                data +
                `${techIntr.type.name} (${techIntr.bpm.average}, ${techIntr.bpm.min}-${techIntr.bpm.max} bpm)`;
            } else {
              data = data + `${techIntr.type.name}`;
            }
          }
        }
      });
    }
    if(veBeatArrayLen > 0){
      data = data == '' ? data + "VE(s)" : data + ", VE(s)";
    }
    if(sveBeatArrayLen > 0){
      data = data == '' ? data + "SVE(s)" : data + ", SVE(s)";
    }
    setTechInterpretationText(data);
  };

  const newlineparser = payload => {
    const lines = payload.split('\n');
    return lines.map((l,i) => (
      <React.Fragment key={i}>
        - {l}
        <br />
      </React.Fragment>
    ));
  };

  useEffect(() => {
    if (Annotator.interpretation.intervals.length && Rhythms.length) {
      getTechInterpretations(Annotator.interpretation.intervals);
    }
  }, [Annotator.interpretation, Rhythms,Annotator.interpretation.beats]);

  useEffect(() => { }, [TechInterpretation]);

  const todayDate = moment()

  return (
    <div className={styles.InfoSidebar}>
      <div className={styles.header}>
        <ContentHeader
          showAddPatient={false}
          enableBackButton={false}
          showLastRefresh={false}
          isFullWidth={true}
          text="Annotation Tool"
          me={me}
        />
      </div>
      <div style={{ display: 'flex' }}>
        <p
          className={styles.worklistButton}
          onClick={() => history.push('/cct/work-list')}
        >
          {' '}
          Worklist{' '}
        </p>
        <div style={{ marginLeft: '18vh', marginTop: '-10px', zIndex: 199 }}>
          <button
            className={styles.exportButton}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              dispatch(handleOnExportClick());
            }}
          >
            Download ECG
          </button>
        </div>
      </div>
      <div className={styles.patientInfo}>
        <p
          onClick={() => {
            dispatch(updateSelectedTab(PATIENT_FILE_TABS.KARDIA_RX));
            history.push(
              createRoute({
                patientId: recordingInfo.patient.participant_id,
                kardiaRxEcg: 'patientSearch',
                idtf_connection_id: props.urlParams.idtf_connection_id,
              }),
            )
          }}
        >
          <span className={styles.boldLable}>Patient:</span>{' '}
          <span className={styles.colorBoldText}>
            <u>
              {recordingInfo.patient.last_name},{' '}
              {recordingInfo.patient.first_name}
            </u>
          </span>
        </p>
        <p
          onClick={() => {
            dispatch(updateSelectedTab(PATIENT_FILE_TABS.KARDIA_RX));
            history.push(
              createRoute({
                patientId: recordingInfo.patient.participant_id,
                kardiaRxEcg: 'patientSearch',
                idtf_connection_id: props.urlParams.idtf_connection_id,
              }),
            )
          }}
        >
          <span className={styles.boldLable}> MRN#:</span>{' '}
          <span className={styles.colorBoldText}>
            {' '}
            <u>
              {recordingInfo.patient.custom_participant_id}
            </u>
          </span>
        </p>
        <p>
          <span className={styles.labaleFixedWidth}>Patient Phone:</span>
          <span className={styles.patientInfoMargin}>
            {recordingInfo.patient.participant_phone}
          </span>
        </p>
        <p>
          {' '}
          <span className={styles.labaleFixedWidth}> DoB(Age): </span>
          <span className={styles.patientInfoMargin}>
            {recordingInfo.patient.dob && (
              <React.Fragment>
                <FormattedDate
                  date={recordingInfo.patient.dob}
                  fmt={getDateFormat(me)}
                />{' '}
                {`(${moment().diff(recordingInfo.patient.dob, 'years')} years)`}
              </React.Fragment>
            )}
          </span>{' '}
          Sex:{' '}
          {recordingInfo.patient.sex != 'not_known' &&
            recordingInfo.patient.sex}
        </p>
        <p>
          {' '}
          <span className={styles.labaleFixedWidth}>Monitoring:</span>
          <span className={styles.patientInfoMargin}>
          {moment(todayDate).isAfter(moment( moment(recordingInfo.patient.study_period_starts_at).format("DD-MM-YYYY"), "DD-MM-YYYY").add(recordingInfo.patient.study_duration_in_days, 'days')) ?
          'Completed' :
            monitoringDate.days > recordingInfo.patient.study_duration_in_days ?
              'Completed' :
              `Day ${monitoringDate.days} of 
              ${recordingInfo.patient.study_duration_in_days}`
            }
           
          </span>
        </p>
        <p>
          <span className={styles.labaleFixedWidth}>Provider:</span>
          <span className={styles.patientInfoMargin}>
            Dr. {recordingInfo.patient.ordering_provider_first_name}
          </span>
        </p>
        <p>
          {' '}
          <span className={styles.labaleFixedWidth}>Practice:</span>
          <span className={styles.patientInfoMargin}>
            {recordingInfo.patient.ordering_provider_team_name}
          </span>
        </p>
        <p>
          <span className={styles.labaleFixedWidth}>Provider Phone:</span>
          <span className={styles.patientInfoMargin}>
            {recordingInfo.patient.ordering_provider_team_phone}
          </span>
        </p>{' '}
        <p style={{ display: 'flex', paddingBottom: '10px' }}>
          {' '}
          <span className={styles.labaleFixedWidth}>MDN:</span>
          <span className={styles.patientInfoMargin + ' ' + styles.mdnList}>
            {recordingInfo.patient.mdnList &&
              newlineparser(recordingInfo.patient.mdnList)}
          </span>
        </p>
      </div>
      <div className={styles.options}>
        <div className={styles.patientInfo}>
          <p>
            {' '}
            <span className={styles.labaleFixedWidth}>Date Received:</span>
            <span className={styles.patientInfoMargin}>
              <FormattedDate
                date={recordingInfo.patient.recording_created_at}
              />
            </span>
          </p>
          <p>
            <span className={styles.labaleFixedWidth}>Implanted Devices: </span>
            <span className={styles.patientInfoMargin}>
              {recordingInfo.patient.implanted_device}
            </span>
          </p>
          {/* <p>Base Rhythm: <span className={styles.patientInfoMargin}></span></p> */}
          <FormLabel className={styles.labaleFixedWidth}>
            <p style={{fontSize: '0.87rem'}}>
              Base Rhythm:
            </p>
          </FormLabel>
          <FormControl className={styles.formFieldSelect}>
            <Select
              labelId="baseRhythm-to-label"
              id="baseRhythm-to"
              value={BaseRhythm || ''}
              onChange={handleBaseRhythmChange}
              disabled={isCompleted}
              MenuProps={{ classes: { paper: classes.menuPaper } }}
            >
              {Rhythms.length &&
                Rhythms.map(item => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <p>
            <span className={styles.labaleFixedWidth}>Overall Average: </span>{' '}
            <span className={styles.patientInfoMargin}>
              {recordingInfo.recording.overall_average &&
                `${recordingInfo.recording.overall_average} BPM`}
            </span>
          </p>
          <p>
            KAV2 Interpretation:{' '}
            <span className={styles.patientInfoMargin}>
              {kav2Ditermination}
            </span>
          </p>
          <p style={{ display: 'flex', paddingBottom: '10px' }}>
            {' '}
            <span className={styles.labaleFixedWidth}>
              Tech Interpretation:
            </span>
            <span
              className={
                styles.patientInfoMargin + ' ' + styles.techInterpretation
              }
            >
              {TechInterpretationsText}
            </span>
          </p>
          <FormLabel className={styles.labaleFixedWidth}>
            <p style={{fontSize: '0.87rem'}}>
              Incidental Findings:
            </p>
          </FormLabel>
          <FormControl className={styles.formFieldSelect}>
            <TextareaAutosize
              rowsMax={6}
              aria-label="maximum height"
              placeholder="Enter findings here"
              value={IncidentalFindings}
              disabled={isCompleted}
              onChange={handleIncidentalFindingsChange}
              style={{ height: '120px' }}
            />
          </FormControl>
          <div className={styles.symptoms}>
            {' '}
            <div className={styles.symptomsLabel}>Symptoms:</div>
            <div className={styles.symptomsMargin}>
              {recordingInfo.recording.symptoms}
            </div>
          </div>

          <p>
            {' '}
            <span className={styles.labaleFixedWidth}>Activity:</span>
            <span className={styles.patientInfoMargin}>
              {recordingInfo.recording.activities}
            </span>
          </p>
        </div>
        <FormControl component="fieldset" className={styles.formField}>
          <p>
            <span className={styles.labaleFixedWidth}>Acuity</span>
          </p>
          <RadioGroup
            className={styles.patientInfoMargin}
            style={{ marginTop: -11 }}
            row
            aria-label="ecgtype"
            name="ecgtype"
            value={ECGType}
            disabled={isCompleted}
            onChange={handleTypeChange}
          >
            <FormControlLabel
              value="stable"
              control={<Radio />}
              disabled={isCompleted}
              label="Stable"
            />
            <FormControlLabel
              style={{fontSize: '0.85rem'}}
              value="mdn"
              disabled={isCompleted}
              control={<Radio />}
              label="MDN"
            />
          </RadioGroup>
        </FormControl>

        <FormControl component="fieldset" className={styles.formField}>
          <p>
            <span className={styles.labaleFixedWidth}>Highlight Strip?</span>
          </p>
          <RadioGroup
            className={styles.patientInfoMargin}
            style={{ marginTop: -11 }}
            row
            aria-label="highlightStripe"
            name="highlightStripe"
            value={HighlightStripeType}
            disabled={isCompleted}
            onChange={handleTypeChangeForStripHighlight}
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              disabled={isCompleted}
              label="Yes"
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              disabled={isCompleted}
              label="No"
            />
          </RadioGroup>
        </FormControl>
        <div>
          <FormLabel className={styles.labaleFixedWidth}><p style={{fontSize: '0.87rem'}}>Send To:</p></FormLabel>
          <FormControl className={styles.formFieldSelect}>
            <Select
              labelId="send-to-label"
              id="send-to"
              value={SendTo}
              disabled={isCompleted}
              onChange={handleSendToChange}
            >
              {/* {Object.keys(sendToList).map(item =>(
                            <React.Fragment key={item}>
                                <MenuItem value={item}>{sendToList[item]}</MenuItem>   
                            </React.Fragment>
                        ))} */}
              <MenuItem value={1}>Triage</MenuItem>
              <MenuItem value={2}>Analysis</MenuItem>
              <MenuItem value={3}>QA</MenuItem>
              <MenuItem value={4}>Completed</MenuItem>
              <MenuItem value={5}>Archive</MenuItem>
            </Select>
          </FormControl>
        </div>
        {SendTo === 5 && (
          <div style={{ marginTop: 2 }}>
            <FormLabel className={styles.labaleFixedWidth}><p style={{fontSize: '0.87rem'}}>Reason:</p></FormLabel>
            <FormControl className={styles.formFieldSelect}>
              <Select
                labelId="reason-to-label"
                id="reason-to"
                value={Reason}
                onChange={handleReasonToChange}
              >
                <MenuItem value={1}>Repeat</MenuItem>
                <MenuItem value={2}>Noise</MenuItem>
                <MenuItem value={3}>Other</MenuItem>
              </Select>
            </FormControl>
          </div>
        )}
      </div>
      <div className={styles.footer}>
        <button className={styles.cctSecondaryButton}> Cancel </button>
          {!isCompleted &&
          <button className={styles.cctPrimaryButton} onClick={handleSubmit}>
            {' '}
            Submit
          </button>
          }
      </div>
    </div>
  );
};

export default AnnotationRecordingInfo;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/container/AnnotationRecordingInfo/AnnotationRecordingInfo.jsx